import { notification } from "antd";
import { createElement } from "react";
import { DefaultError } from "@tanstack/react-query";
interface E extends Error {
  response: {
    data: {
      error: {
        message: string;
      };
    };
  };
}

export const showErrorToast = (err: DefaultError) => {
  const errorData = err as E;
  notification.error({
    message: createElement(
      "p",
      {
        style: {
          marginInline: "10px",
          unicodeBidi: "plaintext",
        },
      },
      errorData?.response?.data?.error.message || errorData.message,
    ),
  });
};
